import { render, staticRenderFns } from "./DirectBillingReport.vue?vue&type=template&id=5061c402&"
import script from "./DirectBillingReport.vue?vue&type=script&lang=js&"
export * from "./DirectBillingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports